import React from 'react';

import DenialImg from '@/assets/imgs/denial.svg';

import Auxiliary from '../Auxiliary';

interface DenialProps {
  handleClose: () => void;
}

export default function Denial({ handleClose }: DenialProps) {
  return (
    <Auxiliary
      screen="denial"
      title="¡Ups! La solicitud no ha sido aprobada"
      subtitle="Lo sentimos... con estos datos no podemos aprobar la operación"
      imgSrc={DenialImg}
      mainButton="Volver"
      handleMainButton={() => handleClose()}
    />
  );
}
